import Container from "@commerce-ui/core2/Container";
import Box from "@commerce-ui/core2/Box";

import React from "react";

const ErrorDomain = () => (
  <Container>
    <Box
      sx={{
        display: "flex",
        mt: "s10",
        color: "main",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "50vh"
      }}
    >
      <Box as={"p"} sx={{ font: "xxl" }}>
        Page not found. 404
      </Box>
    </Box>
  </Container>
);

export default ErrorDomain;
